export const PatientCard = {
  extends: 'Link',
  href: '/patient',
  textDecoration: 'none',
  color: 'inherit',
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid transparent',
  cursor: 'pointer',
  width: '100%',
  transition: 'all 0.2s ease',
  ':hover': { border: '1px solid inkBorder', boxShadow: '0 4px 16px rgba(0,0,0,0.04)' },
  AvatarCircle: {
    text: (el, s) => s.name ? s.name.charAt(0) : '?',
    width: 'C',
    height: 'C',
    round: 'D',
    background: '#0D1117',
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: 'A',
    flow: 'x',
    align: 'center center',
    flexShrink: '0'
  },
  PatientInfo: {
    flow: 'y',
    gap: 'W',
    flex: '1',
    PatientName: { text: (el, s) => s.name, fontSize: 'A', fontWeight: '600', color: 'inkText' },
    PatientMeta: { text: (el, s) => 'Last visit: ' + s.lastVisit + ' · Next: ' + s.nextAppt, fontSize: 'Z', color: 'inkMuted' }
  },
  VisitCount: { text: (el, s) => s.totalVisits + ' visits', fontSize: 'Z', color: 'inkSubtle', fontWeight: '500', flexShrink: '0' }
}
